// extracted by mini-css-extract-plugin
export default {"filled":"UQCHh","size":"HUInK","component":"aur22","component--low":"VTuVf"};